import { Tooltip } from 'antd';
import { Declaration } from 'store/declarations/declaration';
import { getDeclrationCountry, DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { getMessageTypeByDeclaration } from 'views/declarations/utils/declaration-utils';
import { getDeclarationUrl } from 'views/declarations/utils/getDeclarationUrl';
import { getMirrorDucr } from './getMirrorDucr';
import { getMirrorPendingDucrLabel } from './getMirrorPendingDucrLabel';
import { DeclarationLink, LinkText } from './styles';

const PENDING_DUCR_HINT = 'Enter the exporter EORI on this B1 to generate its DUCR.';

const countryAdjective: Record<DeclarationCountry, string> = {
    [DeclarationCountry.IRELAND]: 'Irish',
    [DeclarationCountry.UK]: 'British',
    [DeclarationCountry.EU]: 'EU',
};

const internalTypeLabel: Record<DeclarationInternalType, string> = {
    [DeclarationInternalType.IMPORT]: 'Import',
    [DeclarationInternalType.IMPORT_NEW]: 'Import',
    [DeclarationInternalType.EXPORT]: 'Export',
    [DeclarationInternalType.ENS]: 'ENS',
    [DeclarationInternalType.ETD]: 'ETD',
    [DeclarationInternalType.ARRIVAL]: 'Arrival',
    [DeclarationInternalType.TEMPORARY]: 'TSD',
    [DeclarationInternalType.GVMS]: 'GVMS',
    [DeclarationInternalType.PBN]: 'PBN',
    [DeclarationInternalType.NCTS]: 'NCTS',
    [DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2]: 'Arrival Notification',
};

type Props = {
    declaration: Declaration;
    manifestId?: string;
    jobId?: string;
};

const MirroredDeclarationLink = ({ declaration, manifestId, jobId }: Props) => {
    if (!declaration.id || !declaration.declarationInternalType) return null;

    const to = getDeclarationUrl({ manifestId, jobId, declarationId: declaration.id });
    const ducr = getMirrorDucr(declaration.mirrorDetails);
    const country = getDeclrationCountry(declaration);
    const messageType = getMessageTypeByDeclaration(declaration) as MessageTypes;
    const fallbackLabel = `${countryAdjective[country]} ${
        internalTypeLabel[declaration.declarationInternalType]
    } ${messageType}`;

    const pendingDucrLabel = ducr ? undefined : getMirrorPendingDucrLabel(declaration.mirrorDetails, messageType);
    const label = ducr ?? pendingDucrLabel ?? fallbackLabel;

    return (
        <DeclarationLink to={to} data-testid="mirrored-declaration-link">
            <LinkText>{label}</LinkText>
        </DeclarationLink>
    );
};

export default MirroredDeclarationLink;
